import { APP_HEADER_HEIGHT_VAR, HeaderContent, HEADER_TITLE_CLASS } from '../../components/shell/app-header';

export default function CapApp() {
  return (
    <>
      <HeaderContent width="md" showBurger backTo="/mini-apps" backLabel="Mini-apps">
        <div className="min-w-0">
          <h1 className={HEADER_TITLE_CLASS}>Cap — Planification</h1>
          <p className="m-0 mt-0.5 text-[13px] sm:text-[13.5px] leading-snug text-muted-foreground">
            Prototype — données stockées localement dans ce navigateur.
          </p>
        </div>
      </HeaderContent>
      <iframe
        src="/mini-apps/cap.html"
        title="Cap — Planification"
        className="w-full border-0"
        style={{ height: `calc(100dvh - var(${APP_HEADER_HEIGHT_VAR}, 0px))` }}
        allow="clipboard-write"
      />
    </>
  );
}
